import type { IconButtonProps } from "@mui/material";
import type { ChangeEvent, FC } from "react";
import { usePopover } from "../../../../common/hooks/use-popover";
import { AppIconButton } from "../../../../shared/components/AppIconButton";
import { SettingsIcon } from "../../../../shared/icons/SettingsIcon";
import { ComparisonChatInstruction } from "../ComparisonChatInstruction";
import styles from "./styles.module.css";

interface Props extends IconButtonProps {
  areaValue: string;
  handleChangeInstruction: (event: ChangeEvent<HTMLTextAreaElement>) => void;
}

export const OpenInstructionsButton: FC<Props> = ({
  areaValue,
  handleChangeInstruction,
  ...props
}) => {
  const {
    anchorPopoverEl,
    openPopover,
    handleOpenPopover,
    handleClosePopover,
  } = usePopover();
  return (
    <>
      <AppIconButton
        onClick={handleOpenPopover}
        className={styles["settings-btn"]}
      >
        <SettingsIcon />
      </AppIconButton>
      <ComparisonChatInstruction
        areaValue={areaValue}
        anchorEl={anchorPopoverEl}
        handleChange={handleChangeInstruction}
        onClose={handleClosePopover}
        open={openPopover}
      />
    </>
  );
};
